import { render, staticRenderFns } from "./atlisdialog.vue?vue&type=template&id=3e8aaa9b&scoped=true"
import script from "./atlisdialog.vue?vue&type=script&lang=js"
export * from "./atlisdialog.vue?vue&type=script&lang=js"
import style0 from "./atlisdialog.vue?vue&type=style&index=0&id=3e8aaa9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8aaa9b",
  null
  
)

export default component.exports